// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3TX1K","col":"styles_col__10uqb"};